/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SoftwareVersionDetailConfigProviderEntryEntrypointProps } from './SoftwareVersionDetailConfigProviderEntry.entrypoint.types.tsx';

type SoftwareVersionDetailConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	SoftwareVersionDetailConfigProviderEntryEntrypointProps,
	{} | null
>;

export const softwareVersionDetailConfigProviderEntrypoint: EntryPoint<
	SoftwareVersionDetailConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<SoftwareVersionDetailConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-software-version-detail-config-provider" */ './SoftwareVersionDetailConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
